(() => {
  if (window.__bssTePlacementInstalled) return;
  window.__bssTePlacementInstalled = true;

  let cartDrawerOpen = false;

  function placeForm() {
    const source = document.getElementById('bss-te-source');
    if (!source) return;

    const pageSlot = document.querySelector('[data-bss-te-slot="page"]');
    const drawerSlot = document.querySelector('[data-bss-te-slot="drawer"]');
    const destination = cartDrawerOpen ? drawerSlot : pageSlot || drawerSlot;

    if (!destination) {
      source.hidden = true;
      return;
    }

    // Move the existing form; preserve BSS listeners, VAT input and validation state.
    if (source.parentElement !== destination) destination.appendChild(source);
    source.hidden = false;
  }

  document.addEventListener('headerDrawer:opened', (event) => {
    if (event.target.getAttribute?.('open') !== 'cart:open') return;
    cartDrawerOpen = true;
    placeForm();
  });

  document.addEventListener('headerDrawer:closed', (event) => {
    if (event.target.getAttribute?.('open') !== 'cart:open') return;
    cartDrawerOpen = false;
    placeForm();
  });

  document.addEventListener('shopify:section:load', placeForm);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeForm, { once: true });
  } else {
    placeForm();
  }
})();
